import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Button from '../Button';

var WysiwygField = function WysiwygField(_ref) {
  var html = _ref.html,
      props = _objectWithoutProperties(_ref, ["html"]);

  var parsedHtml = ReactHtmlParser(html, {
    transform: function transform(node) {
      switch (node.name) {
        case 'a':
          {
            if (node.attribs.class && node.attribs.class.indexOf('button--primary') !== -1) {
              var label = node.children[0].data;
              return /*#__PURE__*/React.createElement(Button, {
                primary: true,
                withIcon: true,
                buttonIcon: true,
                href: node.attribs.href,
                target: node.attribs.target || '',
                rel: node.attribs.target ? 'noopener' : '',
                key: "".concat(node.name, ":").concat(label)
              }, label);
            }

            break;
          }

        default:
          {
            break;
          }
      }
    }
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "WysiwygField"
  }, props), parsedHtml);
};

PropTypes.propTypes = {
  html: PropTypes.string.isRequired
};
export default WysiwygField;